/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".exposure-kpi-item[_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;padding-right:14px}.exposure-kpi-item[_ngcontent-%COMP%]:nth-child(2){padding-right:11px;padding-left:5px}.exposure-kpi-item[_ngcontent-%COMP%]:nth-child(3){padding-right:8px;padding-left:8px}.exposure-kpi-item[_ngcontent-%COMP%]:last-child{padding-right:0;padding-left:14px}.kpi-report[_ngcontent-%COMP%]{margin-top:-5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/measure/exposure-kpi-report/exposure-kpi-report.component.scss.shim.ngstyle.js.pre-build-optimizer.js